/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Footer_Badges_TitleInputs */

const en_admin_footer_badges_title = /** @type {(inputs: Admin_Footer_Badges_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Footer badges`)
};

/**
* | output |
* | --- |
* | "Footer badges" |
*
* @param {Admin_Footer_Badges_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_footer_badges_title = /** @type {((inputs?: Admin_Footer_Badges_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Footer_Badges_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_footer_badges_title(inputs)
});
export { admin_footer_badges_title as "admin.footer_badges.title" }